// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3WNTc","buttons":"PendingPaymentAlert_buttons__2FNFa"};